import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "global-container" }
const _hoisted_2 = { class: "left-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "right-container" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "img-container" }
const _hoisted_8 = { class: "store" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "store" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "phone-img",
        src: _ctx.imgPhone,
        alt: "Prévisualisation téléphone"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('home.modale.mobileapp.title')), 1),
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('home.modale.mobileapp.text')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            class: "qrcode",
            src: _ctx.qrCodeAndroid,
            alt: "QR code android"
          }, null, 8, _hoisted_9),
          _createElementVNode("img", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.playStoreLink && _ctx.playStoreLink(...args))),
            class: "links",
            src: _ctx.linkStoreAndroid,
            alt: "Google Play"
          }, null, 8, _hoisted_10)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("img", {
            class: "qrcode",
            src: _ctx.qrCodeApple,
            alt: "QR code apple"
          }, null, 8, _hoisted_12),
          _createElementVNode("img", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.appleStoreLink && _ctx.appleStoreLink(...args))),
            class: "links",
            src: _ctx.linkStoreApple,
            alt: "Apple Store"
          }, null, 8, _hoisted_13)
        ])
      ])
    ])
  ]))
}